// components/HowItWorksSlide.jsx

import chatscreenpreview from "../../assets/chat-screen-preview.png";

export default function MainChatSlide() {
  return (
    <>
      <style>{`
        .login-wrapper{
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:60px;
          flex-wrap:wrap;
        }

        .login-image{
          transition:all 0.4s ease;
        }

        .login-image:hover{
          transform:translateY(-8px);
        }

        .google-btn{
          transition:all 0.35s ease;
        }

        .google-btn:hover{
          transform:translateY(-3px);
          background:rgba(201,168,76,0.08) !important;
          border-color:rgba(201,168,76,0.35) !important;
        }

        @media(max-width:950px){

          .login-wrapper{
            flex-direction:column;
          }

          .login-left{
            max-width:100% !important;
          }

          .login-title{
            font-size:42px !important;
          }
        }

        @media(max-width:700px){

          .login-title{
            font-size:34px !important;
            line-height:1.2 !important;
          }

          .login-desc{
            font-size:17px !important;
          }

          .login-card{
            padding:30px 18px !important;
          }
        }
      `}</style>

      <div
        className="login-card"
        style={{
          width: "100%",
          padding: "60px",
          borderRadius: "34px",
          border:
            "1px solid rgba(201,168,76,0.12)",
          background:
            "linear-gradient(to bottom, rgba(201,168,76,0.04), rgba(201,168,76,0.02))",
          overflow: "hidden",
        }}
      >
        <div className="login-wrapper">
          {/* LEFT */}
          <div
            className="login-left"
            style={{
              flex: 1,
              minWidth: "320px",
              maxWidth: "520px",
            }}
          >
            <span
              style={{
                color: "rgba(201,168,76,0.55)",
                fontFamily: "var(--fell)",
                fontSize: "12px",
                letterSpacing: "2px",
              }}
            >
              GET STARTED
            </span>

            <h2
              className="login-title"
              style={{
                marginTop: "22px",
                marginBottom: "24px",
                color: "var(--parch)",
                fontFamily: "var(--fell)",
                fontSize: "58px",
                lineHeight: 1.08,
                fontWeight: 400,
              }}
            >
             Talk here with any AI companion under calm environment of healing frequency
            </h2>

            <p
              className="login-desc"
              style={{
                color: "var(--parch3)",
                fontFamily: "var(--corm)",
                fontStyle: "italic",
                fontSize: "22px",
                lineHeight: 1.9,
                marginBottom: "36px",
              }}
            >
              Ask anything here , AI companion will reflect according to it's nature
            </p>

 
          </div>

          {/* RIGHT IMAGE */}
          <div
            style={{
              flex: 1,
              minWidth: "320px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              className="login-image"
              style={{
                width: "100%",
                maxWidth: "770px",
                borderRadius: "28px",
                overflow: "hidden",
                border:
                  "1px solid rgba(201,168,76,0.14)",
                boxShadow:
                  "0 30px 80px rgba(0,0,0,0.35)",
              }}
            >
              <img
                src={chatscreenpreview}
                alt="Mysamadhi login with Google interface"
                style={{
                  width: "100%",
                  display: "block",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}